import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { Channel_CODE_SET } from '../../../../config/CgmCodeSet';
import { CHANNEL_COLOR_SET, SENTIMENT_COLOR_SET } from '../../../../config/ColorSet';
import { SENTIMENT_SET } from '../../../../config/SentimentSet';
import GraphModal from '../../modal/GraphModal';

const resultToVolumePieData = (data) => {
  let pieData = [];

  data.channel.forEach((chItem) => {
    let chValue = 0;
    let date = '';
    let end_date = '';
    data.data.forEach((dataItem, index) => {
      chValue = chValue + dataItem[chItem];
      if(index == 0) date = dataItem.date;
      if(index == data.data.length-1) {
        if (dataItem.hasOwnProperty('end_date')){
          end_date = dataItem.end_date;
        }
        else end_date = dataItem.date;
      }
    })
    pieData.push({
      "channel": Channel_CODE_SET[chItem],
      "value": chValue,
      "color": am4core.color(CHANNEL_COLOR_SET[chItem]),
      "date": date,
      "end_date": end_date
    })
  })

  return pieData;
}

const resultToSentimentPieData = (data) => {
  let pieData = [];

  ['positive', 'negative', 'mix', 'neutral'].forEach((sentimentItem) => {
    let sentimentValue = 0;
    let date = '';
    let end_date = '';

    data.data.forEach((dataItem, index)=>{
      sentimentValue = sentimentValue + dataItem[sentimentItem];
      if(index == 0) date = dataItem.date;
      if(index == data.data.length-1) {
        if (dataItem.hasOwnProperty('end_date')){
          end_date = dataItem.end_date;
        }
        else end_date = dataItem.date;
      }
    })
    pieData.push({
      "value": sentimentValue,
      "sentiment": SENTIMENT_SET[sentimentItem],
      "color": am4core.color(SENTIMENT_COLOR_SET[sentimentItem]),
      "channel": Channel_CODE_SET[data.channel],
      "date": date,
      "end_date": end_date
    })
  })

  return pieData;
}

class PieForReport extends Component{
  constructor(props){
    super(props);
    this.state = {
      clickedData: null,
      showModal : false
    }
  }

  componentDidMount() {
    const data = this.props.data;
    const excelExportFunc = this.props.excelExportFunc;
    const reportType = this.props.reportType;
    const reportName = this.props.reportName;
    const type = this.props.type;

    let chart = null;

    switch(reportType){
      case "volume": {
        this.createVolumePieForReport(type, chart, reportName, data, excelExportFunc);
        break;
      }
      case "sentiment": {
        this.createSentimentPieForReport(type, chart, reportName, data, excelExportFunc);
        break;
      }
      default:
        break;
    }
  }

  componentWillUnmount() {
    if(this.chart) this.chart.dispose();
  }

  componentDidUpdate(prevProps){
    if((this.props.data != null) && (prevProps.data !== this.props.data)){
      if(this.chart){
        this.chart.dispose();
      }
      const data = this.props.data;
      const excelExportFunc = this.props.excelExportFunc;
      const reportType = this.props.reportType;
      const reportName = this.props.reportName;
      const type = this.props.type;

      let chart = null;

      switch(reportType){
        case "volume": {
          this.createVolumePieForReport(type, chart, reportName, data, excelExportFunc);
          break;
        }
        case "sentiment": {
          this.createSentimentPieForReport(type, chart, reportName, data, excelExportFunc);
          break;
        }
        default:
          break;
      }
    }
  }

  createBuzzlistWindow = (data) => {
    this.setState(state => ({
      ...state,
      // showWindowPortal: !state.showWindowPortal,
      clickedData: data,
      showModal: true
    }));
    
    let retJSON = {
      sub_query_type: this.props.subQueryType,
      retwit: this.props.reTweet == "true",
      reportType: "buzzlist",
      name: "결과_미리보기",
      channel: this.props.channels,
      query: [this.props.mainQuery, ...this.props.subQuery]
    }
    if (data.hasOwnProperty('end_date')){
      retJSON.dateRange = [data.date.replace(/\-/g,""), data.end_date.replace(/\-/g,"")]
    }
    else {
      retJSON.dateRange = [data.date.replace(/\-/g,""), data.date.replace(/\-/g,"")]
    }
  }

  closeBuzzlistWindow = () => {
    this.setState(state => ({
      ...state,
      // showWindowPortal: !state.showWindowPortal,
      showModal: false
    }));  
  }

  createVolumePieForReport = (type, chart, reportName, dataSet, excelExportFunc) => {
    chart = am4core.create(this.pieChart, am4charts.PieChart);
    am4core.useTheme(am4themes_animated);

    chart.data = resultToVolumePieData(dataSet);
    chart.padding(0,0,0,0);

    let name = dataSet.query.join(' & ');
    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "channel";
    series.slices.template.propertyFields.fill = "color";
    series.slices.template.tooltipText = `${name} ({channel}): [bold]{value.percent.formatNumber('#.#')}%[/] ({value.value})`;
    series.labels.template.text = `${name} ({channel}): [bold]{value}[/]`

    if (type == 'snapshot') {
      series.labels.template.disabled =true;
    }

    
    series.slices.template.events.on("hit", (ev) => {
      this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    })
    let hs = series.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    let as = series.slices.template.states.getKey("active");
    as.properties.shiftRadius = 0;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("pie-export-container");
    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]

    chart.legend = new am4charts.Legend();

    this.chart = chart;
  }

  createSentimentPieForReport = (type, chart, reportName, dataSet, excelExportFunc) => {
    chart = am4core.create(this.pieChart, am4charts.PieChart);
    am4core.useTheme(am4themes_animated);

    chart.data = resultToSentimentPieData(dataSet);
    chart.padding(0,0,0,0);

    let name = dataSet.query.join(' & ');
    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "sentiment";
    series.slices.template.propertyFields.fill = "color";
    series.slices.template.tooltipText = `${name} ({channel}) ({sentiment}): [bold]{value.percent.formatNumber('#.#')}%[/] ({value.value})`;
    series.labels.template.text = `${name} ({channel}) ({sentiment}): [bold]{value}[/]`

    series.slices.template.events.on("hit", (ev) => {
      this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    })
    let hs = series.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    let as = series.slices.template.states.getKey("active");
    as.properties.shiftRadius = 0;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("pie-export-container");
    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]

    chart.legend = new am4charts.Legend();

    this.chart = chart;
  }

  render() {
    return(
      <div>
        <div id="pie-export-container" style={{position:"relative", minHeight:"30px"}}/>
        <div id="pie" ref={ref=>(this.pieChart=ref)} style={{ width: this.props.width, height: this.props.height}}></div>
        <GraphModal showModal={this.state.showModal} closeBuzzlistWindow={this.closeBuzzlistWindow}
          clickedData={this.state.clickedData} reportType={this.props.reportType} mainQuery={this.props.mainQuery} subQuery={this.props.subQuery} subQueryType={this.props.subQueryType} reTweet={this.props.reTweet} channels={this.props.channels}
          userRole={this.props.userRole}
          />
      </div>
    )
  }
}

export default PieForReport;
